import { render, staticRenderFns } from "./_offers.componentV2.vue?vue&type=template&id=65e7c714&scoped=true"
import script from "./_offers.componentV2.vue?vue&type=script&lang=js"
export * from "./_offers.componentV2.vue?vue&type=script&lang=js"
import style0 from "./_offers.componentV2.vue?vue&type=style&index=0&id=65e7c714&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e7c714",
  null
  
)

export default component.exports